import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Číselné pole s nulou: po kliknutí se nula označí, takže psaní ji nahradí
// místo „010“. Platí pro všechna číselná pole v aplikaci najednou.
document.addEventListener("focusin", (e) => {
  const el = e.target;
  if (el instanceof HTMLInputElement && el.value === "0"
      && (el.type === "number" || el.inputMode === "decimal" || el.inputMode === "numeric")) {
    try { el.select(); } catch { /* některé typy výběr nepodporují */ }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
